<script context="module">
	export { default as pre } from '../components/CodeBlock.svelte';
</script>

<script>
	import 'prism-themes/themes/prism-material-oceanic.css';
	import Container from '$lib/experimental/Container';
	import Flex from '$lib/Flex';
	import TOC from '../components/TOC.svelte';
	import styles from './styles.module.css';

	export let title = '';

	/** @type {Element} */
	let content;
</script>

<svelte:head>
	{#if title}<title>{title}</title>{/if}
</svelte:head>

<Container as="article">
	<Flex valign="top">
		<div bind:this={content} class={styles.content}>
			<slot />
		</div>
		<TOC {content} />
	</Flex>
</Container>
